import React from 'react';

// Neutral landing page for managers whose permission profile does not grant
// access to the summary statistics dashboard. It must not require any feature
// or fetch any data, so every authenticated manager can land on it.
const HomeBasic: React.FC = () => <h1>Home</h1>;

export default HomeBasic;
